/*!**************************Confidential and Proprietary*****************************
* File Name: BarChart.ts
********************Copyright (c) Hyland Software, Inc. 1992-2023********************/

import { DataChartModel } from './Models'

export class PieChart {
    public ChartContainer: any;
    public Chart: any;

    private token: string = null;
    private Legend: any = null;
    private InstanceID: any = null;

    constructor(public Container, public Model: DataChartModel) {
        this.InstanceID = typeof (Model.instanceID) === 'undefined' ? 0 : Model.instanceID;
        this.Container = typeof (Container) === 'string' ? $('#' + Container) : Container;
        this.Model = Model;
        this.token = Model.token;
    }

    public Render() {
        const self = this;
        this.ChartContainer = $('<div>')
            .addClass('chart')
            .attr('id', 'chart_' + this.InstanceID);
        this.Container.append(this.ChartContainer);
        const strRcOthers = self.Model.strings !== null && typeof (self.Model.strings.STR_RC_OTHERS) === 'string' ? self.Model.strings.STR_RC_OTHERS : 'Others';

        this.ChartContainer.igPieChart({
            width: '99%',
            height: '99%',
            dataSource: this.Model.data,
            dataValue: 'Value',
            dataLabel: 'Label',
            showTooltip: true,
            othersCategoryThreshold: 1,
            othersCategoryText: strRcOthers,
            tooltipTemplate: '<div> {{if ${item.Label}.length > 0 }} <div class="bold">${item.Label}</div><div>${item.Value}</div> {{else}} <div class="bold">' + strRcOthers + '</div>{{/if}}</div>',
            sliceClick: this.ItemClicked.bind(this),
            legendItemTemplate: {
                render: function (renderInfo) {
                    const data = renderInfo.data.flatten();

                    let labelStr = data.item.Label;
                    if (data.isOthersSlice) {
                        labelStr = strRcOthers;
                    }
                    const legendContentContainer = renderInfo.context;

                    const label = $('<span>').text(labelStr);
                    const labelCell = $('<td>').addClass('ui-chart-legend-item-text').append(label);


                    const outlineColor = data.outline.__fill;

                    const percent = .20;
                    const f = outlineColor.split(',');
                    const t = percent < 0 ? 0 : 255;
                    const p = percent < 0 ? percent * -1 : percent;
                    const red = parseInt(f[0].slice(4), 10);
                    const green = parseInt(f[1], 10);
                    const blue = parseInt(f[2], 10);

                    const redStr = (Math.round((t - red) * p) + red);
                    const greenStr = (Math.round((t - green) * p) + green);
                    const blueStr = (Math.round((t - blue) * p) + blue);

                    const color = 'rgb(' + redStr + ',' + greenStr + ',' + blueStr + ')';

                    const canvas = document.createElement('canvas');

                    let height = 19;
                    let width = 18;

                    $(canvas).attr('height', height).attr('width', width).height(height).width(width);

                    const context = canvas.getContext('2d');

                    const y = 5;
                    const x = 1;
                    height = height - 1 - y;
                    width = width - x - 2;
                    const radius = {
                        tl: 5,
                        tr: 0,
                        bl: 0,
                        br: 5
                    };
                    context.beginPath();
                    context.moveTo(x + radius.tl, y);
                    context.lineTo(x + width - radius.tr, y);
                    context.quadraticCurveTo(x + width, y, x + width, y + radius.tr);
                    context.lineTo(x + width, y + height - radius.br);
                    context.quadraticCurveTo(x + width, y + height, x + width - radius.br, y + height);
                    context.lineTo(x + radius.bl, y + height);
                    context.quadraticCurveTo(x, y + height, x, y + height - radius.bl);
                    context.lineTo(x, y + radius.tl);
                    context.quadraticCurveTo(x, y, x + radius.tl, y);
                    context.closePath();

                    context.fillStyle = color;
                    context.fill();
                    context.lineWidth = 2;
                    context.strokeStyle = outlineColor;
                    context.stroke();

                    const badgeCell = $('<td>').addClass('ui-chart-legend-item-badge').append(canvas);

                    legendContentContainer.append(badgeCell).append(labelCell);
                }
            }
        });

        this.RenderLegend();

        this.RenderLabels();

        if ($('html').css('direction') === 'rtl') {
            this.ChartContainer.css('direction', 'ltr');
        }
    }

    public ItemClicked = function (evt, ui) {
        if ($.isFunction(this.Model.methods.itemClicked)) {
            this.Model.methods.itemClicked(ui.slice.item);
        }
    }

    public ToggleLegend() {
        this.Model.displayLegend = !this.Model.displayLegend;
        if (this.Model.displayLegend) {
            this.Legend.show();
            this.RenderLegend();
        }
        else {
            this.Legend.hide();
            this.ChartContainer.igPieChart({
                width: '99%'
            });
        }
    }

    public ToggleLabels() {
        this.Model.displayLabels = !this.Model.displayLabels;
        this.RenderLabels();
    }

    public GetImage() {
        const image = this.ChartContainer.igPieChart('exportImage', this.ChartContainer.width(), this.ChartContainer.height());
        return $(image).attr('src');
    }

    public RotateRight() {
        let startAngle = this.ChartContainer.igPieChart('option', 'startAngle');
        if (startAngle + 5 > 360) {
            startAngle = -5;
        }
        this.ChartContainer.igPieChart('option', 'startAngle', startAngle + 5);
    }

    public RotateLeft() {
        let startAngle = this.ChartContainer.igPieChart('option', 'startAngle');
        if (startAngle - 5 < 0) {
            startAngle = 360;
        }
        this.ChartContainer.igPieChart('option', 'startAngle', startAngle - 5);
    }

    public Print() {
        this.ChartContainer.igPieChart('print');
    }

    private RenderLegend() {
        if (this.Model.displayLegend) {
            const legendID = 'legend_' + this.InstanceID;

            if (this.Legend === null) {
                this.Legend = $('<div>')
                    .addClass('legend')
                    .attr('id', legendID);
                this.Container.append(this.Legend);
            }

            this.ChartContainer.igPieChart({
                legend: { element: legendID },
                width: '66%'
            });
        }
    }

    private RenderLabels() {
        if (this.Model.displayLabels) {
            this.ChartContainer.igPieChart({
                labelsPosition: 'bestFit',
            });
        }
        else {
            this.ChartContainer.igPieChart({
                labelsPosition: 'none',
            });
        }
    }
}
